export default "__VITE_ASSET__DFYFeEYL__"